import { AI_SUMMARY_TYPES } from '@/features/factFind/factFindApi';

// Folio Engage report types: the Generate menu item's title, the name used in the
// SharePoint retry banner, and the AI summary each one sends to Engage as its source
// document.
export const ENGAGE_REPORT_TYPES = {
	pre_renewal_report: {
		title: 'Generate Pre Renewal Report',
		name: 'Pre Renewal Report',
		summaryType: AI_SUMMARY_TYPES.riskInfoSummary,
	},
	renewal_terms_report: {
		title: 'Generate Renewal Terms',
		name: 'Renewal Terms',
		summaryType: AI_SUMMARY_TYPES.quoteSummary,
	},
	new_business_proposal: {
		title: 'Generate New Business Proposal',
		name: 'New Business Proposal',
		summaryType: AI_SUMMARY_TYPES.quoteSummary,
	},
};

export const ENGAGE_REPORT_STATUSES = {
	complete: 'complete',
	failed: 'failed',
	skipped: 'skipped',
	dismissed: 'dismissed',
};

// The report was generated but its Word copy only failed to save to SharePoint: the
// Firebase copy exists, so the user can retry saving it from the deal's banner.
export const isSharepointOnlyFailure = (report) => {
	const reasons = report.failureReasons ?? [];
	return (
		report.status === ENGAGE_REPORT_STATUSES.failed &&
		reasons.includes('sharepoint') &&
		!reasons.includes('firebase')
	);
};
